// extracted by mini-css-extract-plugin
module.exports = {"paymentBox":"PayBlock_paymentBox__g_MQr","administrationFee":"PayBlock_administrationFee___VgCn"};